module.exports = __webpack_public_path__ + "static/media/portfolio6.547ca8a1.png";